function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2a343f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "settings-svgrepo-com",
  transform: "translate(0 -.05)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3224",
  "data-name": "Group 3224",
  transform: "translate(0 .05)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4171",
  "data-name": "Path 4171",
  className: "cls-1",
  d: "M30.323 13.051h-1.38a12.891 12.891 0 0 0-1.46-3.514l.98-.98a2.109 2.109 0 0 0 0-2.987L26.9 4.01a2.109 2.109 0 0 0-2.987 0l-.971.99a12.978 12.978 0 0 0-3.514-1.46V2.157A2.111 2.111 0 0 0 17.322.05h-2.2a2.111 2.111 0 0 0-2.107 2.107v1.38A12.891 12.891 0 0 0 9.5 5l-.98-.98a2.109 2.109 0 0 0-2.987 0L3.967 5.577a2.109 2.109 0 0 0 0 2.987l.98.973a12.978 12.978 0 0 0-1.46 3.514h-1.38A2.111 2.111 0 0 0 0 15.158v2.2a2.111 2.111 0 0 0 2.107 2.107h1.38a12.891 12.891 0 0 0 1.46 3.514l-.98.98a2.109 2.109 0 0 0 0 2.987l1.56 1.56a2.109 2.109 0 0 0 2.987 0l.98-.98a12.978 12.978 0 0 0 3.514 1.46v1.38a2.111 2.111 0 0 0 2.107 2.107h2.2a2.111 2.111 0 0 0 2.107-2.107v-1.38a12.891 12.891 0 0 0 3.514-1.46l.98.98a2.109 2.109 0 0 0 2.987 0l1.56-1.56a2.109 2.109 0 0 0 0-2.987l-.98-.967a12.978 12.978 0 0 0 1.46-3.514h1.38a2.111 2.111 0 0 0 2.107-2.107v-2.2a2.114 2.114 0 0 0-2.107-2.12zm.507 4.314a.506.506 0 0 1-.507.507H28.3a.8.8 0 0 0-.787.647 11.42 11.42 0 0 1-1.714 4.14.8.8 0 0 0 .1 1.013l1.433 1.433a.515.515 0 0 1 0 .72l-1.56 1.56a.515.515 0 0 1-.72 0l-1.433-1.433a.806.806 0 0 0-1.013-.1 11.3 11.3 0 0 1-4.14 1.714.8.8 0 0 0-.647.787v2.02a.506.506 0 0 1-.507.507h-2.2a.506.506 0 0 1-.507-.507v-2.02a.8.8 0 0 0-.647-.787 11.42 11.42 0 0 1-4.14-1.714.779.779 0 0 0-.447-.133.8.8 0 0 0-.567.233l-1.43 1.434a.515.515 0 0 1-.72 0l-1.56-1.56a.515.515 0 0 1 0-.72l1.433-1.433a.806.806 0 0 0 .1-1.013 11.3 11.3 0 0 1-1.714-4.14.8.8 0 0 0-.787-.647H2.107a.506.506 0 0 1-.507-.507v-2.2a.506.506 0 0 1 .507-.507h2.02a.8.8 0 0 0 .787-.647 11.42 11.42 0 0 1 1.714-4.14.8.8 0 0 0-.1-1.013L5.094 7.424a.515.515 0 0 1 0-.72l1.56-1.56a.515.515 0 0 1 .72 0l1.434 1.433a.806.806 0 0 0 1.013.1 11.3 11.3 0 0 1 4.14-1.714.8.8 0 0 0 .647-.787V2.157a.506.506 0 0 1 .507-.507h2.2a.506.506 0 0 1 .507.507v2.02a.8.8 0 0 0 .647.787 11.42 11.42 0 0 1 4.14 1.714.8.8 0 0 0 1.013-.1l1.433-1.433a.515.515 0 0 1 .72 0l1.56 1.56a.515.515 0 0 1 0 .72L25.9 8.858a.806.806 0 0 0-.1 1.013 11.3 11.3 0 0 1 1.714 4.14.8.8 0 0 0 .787.647h2.02a.506.506 0 0 1 .507.507v2.2z",
  transform: "translate(0 -.05)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4172",
  "data-name": "Path 4172",
  className: "cls-1",
  d: "M294.184 163.067a.8.8 0 1 0-.6.267.82.82 0 0 0 .6-.267z",
  transform: "translate(-273.268 -150.959)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4173",
  "data-name": "Path 4173",
  className: "cls-1",
  d: "M274.924 313.459a.8.8 0 0 0 .373 1.507.757.757 0 0 0 .373-.093.8.8 0 1 0-.747-1.413z",
  transform: "translate(-256.195 -292.477)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4174",
  "data-name": "Path 4174",
  className: "cls-1",
  d: "M254.337 141.021a.8.8 0 1 0-.38 1.553.953.953 0 0 0 .193.02.8.8 0 0 0 .187-1.574z",
  transform: "translate(-236.456 -131.6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4175",
  "data-name": "Path 4175",
  className: "cls-1",
  d: "M155.2 284.153a.8.8 0 1 0 1.113.207.8.8 0 0 0-1.113-.207z",
  transform: "translate(-144.53 -265.078)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4176",
  "data-name": "Path 4176",
  className: "cls-1",
  d: "M308.916 283.953a.8.8 0 0 0-.907 1.32.823.823 0 0 0 .453.14.8.8 0 0 0 .453-1.46z",
  transform: "translate(-287.147 -264.891)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4177",
  "data-name": "Path 4177",
  className: "cls-1",
  d: "M324.3 242.267a.8.8 0 0 0-.887.7.793.793 0 0 0 .7.887.474.474 0 0 0 .093.007.8.8 0 0 0 .093-1.594z",
  transform: "translate(-301.848 -226.112)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4178",
  "data-name": "Path 4178",
  className: "cls-1",
  d: "M318.789 199.739a.871.871 0 0 0 .287-.053.8.8 0 1 0-.287.053z",
  transform: "translate(-296.786 -184.93)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4179",
  "data-name": "Path 4179",
  className: "cls-1",
  d: "M140.511 243.167a.8.8 0 1 0-.8.9.409.409 0 0 0 .093-.007.8.8 0 0 0 .707-.893z",
  transform: "translate(-129.65 -226.299)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4180",
  "data-name": "Path 4180",
  className: "cls-1",
  d: "M144.859 199.842a.841.841 0 0 0 .287.053.793.793 0 0 0 .747-.52.8.8 0 0 0-1.5-.567.8.8 0 0 0 .466 1.034z",
  transform: "translate(-134.718 -185.074)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4181",
  "data-name": "Path 4181",
  className: "cls-1",
  d: "M232.013 324.05H232a.8.8 0 0 0 0 1.6h.013a.8.8 0 1 0 0-1.6z",
  transform: "translate(-215.785 -302.448)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4182",
  "data-name": "Path 4182",
  className: "cls-1",
  d: "M210.424 141.707a.8.8 0 1 0-.78.987.675.675 0 0 0 .193-.027.787.787 0 0 0 .587-.96z",
  transform: "translate(-194.923 -131.693)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4183",
  "data-name": "Path 4183",
  className: "cls-1",
  d: "M189.189 313.559a.8.8 0 0 0-.747 1.414.836.836 0 0 0 .373.093.8.8 0 0 0 .373-1.507z",
  transform: "translate(-175.481 -292.57)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4184",
  "data-name": "Path 4184",
  className: "cls-1",
  d: "M170.984 162.075a.8.8 0 1 0-.593 1.327.817.817 0 0 0 .533-.2.794.794 0 0 0 .06-1.127z",
  transform: "translate(-158.283 -151.021)"
})));

function SvgMyAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.43,
    height: 32.424,
    viewBox: "0 0 32.43 32.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIcon);
export default __webpack_public_path__ + "static/media/my-account-icon.ad8ee016.svg";
export { ForwardRef as ReactComponent };